import { API } from '../api';

export function logIn(data: { email: string; password: string }) {
    return API.post(API.PATH.login, data).then((response) => response.data);
}
